// ============================================================================
// gradeDiaria: o que gravar em fk_avec_daily_cache para cada (dia, unidade)
// (A9 do "Dashboard sem zero silencioso", 23/10/2026). Puro.
// ============================================================================
//   ok (valor > 0)            → valor          (sobrescreve, inclusive para menos: estorno)
//   vazio, anterior > 0       → anterior       (200 vazio não apaga valor bom; fica no log)
//                               ...até o vazio se REPETIR (revisão 23/10/2026, achado 14):
//                               VAZIO_GRADE.minRodadas respostas vazias seguidas por pelo
//                               menos passadoMs (dia passado) ou hojeMs (o dia de hoje)
//                               → 0, o zero real do Avec (a única venda foi cancelada);
//   vazio, sem anterior > 0   → 0              (domingo / dia sem venda: zero legítimo)
//   falhou, com anterior      → anterior       (como hoje)
//   falhou, sem anterior      → AUSENTE        (hoje gravava 0; dia ausente cai no
//                                               lançamento manual daquele dia e a
//                                               gerente usa o 0281 do período)
// ============================================================================

export const AUSENTE = Symbol('ausente');

// Vazio que se repete: só depois disso o 200 vazio troca um valor bom por 0.
export const VAZIO_GRADE = Object.freeze({ minRodadas: 3, passadoMs: 10 * 60_000, hojeMs: 2 * 3600_000, guardarMs: 45 * 24 * 3600_000 });
// Marca do aparelho (não vai para a nuvem): { 'YYYY-MM-DD|unidade': { n, desde } }
export const CHAVE_VAZIOS_GRADE = 'fk_avec_grade_vazios';

export function decidirValorDia(anterior, resultado, { vazio = null, ehHoje = false, agora = Date.now() } = {}) {
  const temAnterior = anterior !== undefined && anterior !== null;
  const est = resultado?.estado;
  if (est === 'ok' && Number(resultado.valor) > 0) return Number(resultado.valor);
  if (est === 'ok' || est === 'vazio') {
    if (temAnterior && Number(anterior) > 0) {
      const n = Number(vazio?.n) || 0;
      const desde = Number(vazio?.desde);
      const espera = ehHoje ? VAZIO_GRADE.hojeMs : VAZIO_GRADE.passadoMs;
      if (n >= VAZIO_GRADE.minRodadas && Number.isFinite(desde) && agora - desde >= espera) return 0;
      return anterior;
    }
    return 0;
  }
  // falhou
  return temAnterior ? anterior : AUSENTE;
}

export function lerVaziosGrade(raw) {
  try {
    const o = JSON.parse(raw || '{}');
    return o && typeof o === 'object' && !Array.isArray(o) ? o : {};
  } catch { return {}; }
}

/** Conta as respostas vazias SEGUIDAS de (dia, unidade). ok/aceito zera; falha não mexe. */
export function anotarVazioGrade(vazios, chave, estado, agora = Date.now()) {
  const atual = vazios?.[chave];
  if (estado === 'vazio') {
    return { ...(vazios || {}), [chave]: { n: (Number(atual?.n) || 0) + 1, desde: Number.isFinite(Number(atual?.desde)) ? Number(atual.desde) : agora } };
  }
  if ((estado === 'ok' || estado === 'aceito') && atual) {
    const out = { ...vazios };
    delete out[chave];
    return out;
  }
  return vazios || {};
}

/** JSON para o localStorage, sem marcas velhas (mais de guardarMs). */
export function gravarVaziosGrade(vazios, agora = Date.now()) {
  const out = {};
  for (const [k, v] of Object.entries(vazios || {})) {
    if (v && Number.isFinite(Number(v.desde)) && agora - Number(v.desde) < VAZIO_GRADE.guardarMs) out[k] = v;
  }
  return JSON.stringify(out);
}

/** Dias do período (até hoje) em que a unidade não tem valor na grade. */
export function diasAusentesNaGrade(gradeDiaria, unitKey, inicioISO, fimISO, hojeISO) {
  if (!unitKey || !inicioISO || !fimISO) return [];
  const out = [];
  const [ys, ms, ds] = inicioISO.split('-').map(Number);
  const fim = fimISO < hojeISO ? fimISO : hojeISO;
  const d = new Date(ys, ms - 1, ds);
  for (let i = 0; i < 400; i++) {
    const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    if (iso > fim) break;
    const v = gradeDiaria?.[iso]?.[unitKey];
    if (v === undefined || v === null) out.push(iso);
    d.setDate(d.getDate() + 1);
  }
  return out;
}
